import {
    InfoHint,
    InfoHintBody,
    InfoHintContent,
    InfoHintHeader,
    InfoHintTitle,
    InfoHintTrigger,
} from '@plato/ui/components/info-hint';
import { cn } from '@plato/ui/util/classes';
import type { LucideIcon } from 'lucide-react';
import { ChevronLeftIcon, XIcon } from 'lucide-react';
import type React from 'react';
import { Button } from './button.tsx';
import { Heading } from './heading.tsx';

export type HeaderProps = {
    title?: React.ReactNode;
    subTitle?: string;
    actions?: React.ReactNode;
    onBack?: () => void;
    onClose?: () => void;
    icon?: LucideIcon;
    className?: string;
} & React.PropsWithChildren;

export function Header({
    className,
    title,
    actions,
    subTitle,
    onBack,
    onClose,
    icon: Icon,
    children,
}: HeaderProps) {
    return (
        <div className={cn('flex flex-col gap-2', className)}>
            <div className="flex flex-row flex-wrap gap-3">
                <div className="flex min-w-0 gap-2 grow">
                    {onBack && <Button icon={ChevronLeftIcon} variant="icon" onClick={onBack} />}
                    <div className="flex min-w-0 grow flex-row items-center gap-2">
                        {Icon && <Icon className="h-4 w-4" />}
                        <Heading>{title}</Heading>
                        {subTitle && (
                            <InfoHint>
                                <InfoHintTrigger />
                                <InfoHintContent>
                                    <InfoHintHeader>
                                        <InfoHintTitle>{title}</InfoHintTitle>
                                    </InfoHintHeader>
                                    <InfoHintBody>{subTitle}</InfoHintBody>
                                </InfoHintContent>
                            </InfoHint>
                        )}
                        {children}
                    </div>
                </div>
                {(actions || onClose) && (
                    <div className="flex gap-3 flex-wrap">
                        {actions}
                        {onClose && <Button variant="icon" onClick={onClose} icon={XIcon} />}
                    </div>
                )}
            </div>
        </div>
    );
}
